<template>
  <form :id="'frm-'+id"
        class="px-3"
        method="post"
        onsubmit="return false">
    <div :id="id"
         :aria-labelledby="id+'-title'"
         aria-hidden="true"
         class="modal fade"
         role="dialog"
         tabindex="-1">
      
      <div class="modal-dialog modal-dialog-scrollable" role="document">
        <div class="modal-content">
          <div class="modal-header mb-2">
            <h5 :id="id+'-title'" class="modal-title">{{ title }}</h5>
          </div>
          <div class="modal-body">
            <div class="form-group">
              <label for="key">Clave: *</label>
              <input type="text"
                     id="key"
                     placeholder="Clave de la disciplina. Puede ser una abreviación del nombre."
                     class="form-control"
                     v-model="disciplineKey"/>
            </div>
  
            <div class="form-group">
              <label for="title">Nombre: *</label>
              <input type="text"
                     id="title"
                     placeholder="Nombre de la disciplina"
                     class="form-control"
                     v-model="disciplineTitle"/>
            </div>
          </div>
          
          <div class="modal-footer flex px-2 shadow-none modal-body-scrolled">
            <button :disabled="saving"
                    class="btn btn-primary mr-2"
                    type="button"
                    @click="createDiscipline">
              <template v-if="!saving">Guardar</template>
              <span v-if="saving"
                    class="spinner-border text-yellow-500 spinner-border-sm"
                    role="status">
                <span class="sr-only">Agregando...</span>
              </span>
            </button>
            
            <button class="btn btn-secondary"
                    data-dismiss="modal"
                    type="button"
                    :disabled="saving">Cancelar
            </button>
          </div>
        </div>
      </div>
    </div>
  </form>
</template>

<script>
  import { mapActions } from 'vuex'
  import { AlertManager } from '../utils/AlertManager'
  import 'jquery-validation'
  
  export default {
    name: 'AddDisciplineModal',
    props: {
      title: {
        default: 'Agregar disciplina',
      },
      id: {
        default: 'add-discipline-modal',
      },
      science: Object,
    },
    data () {
      return {
        saving: false,
        disciplineKey: '',
        disciplineTitle: '',
      }
    },
    methods: {
      ...mapActions({
        saveDiscipline: 'catalogs/saveDiscipline',
      }),

      clearform () {
        this.disciplineKey = ''
        this.disciplineTitle = ''
      },
      
      async createDiscipline () {
        this.saving = true
        
        const {
                disciplineKey,
                disciplineTitle,
                science,
              } = this
        
        const response = await this.saveDiscipline({
          key: disciplineKey,
          title: disciplineTitle,
          science_id: science.id,
        })
        
        const {
                status,
                message,
                error,
                discipline,
              } = response.data.data
        
        if (status === 'error') {
          AlertManager.error(error)
          
          return
        }
        
        AlertManager.notification(message)
        
        this.saving = false

        this.clearform()
        
        $(`#${this.id}`).modal('hide')
        
        this.$emit('discipline-saved', discipline)
      },
    },
    mounted() {
      $('form', this.$el).validate({
        ignore: [],
        highlight: function (element) {
          $(element).addClass('is-invalid')
        },
        unhighlight: function (element) {
          $(element).removeClass('is-invalid')
        },
        errorPlacement: function (label, element) {
          if (element.hasClass('select2-input')) {
            label.insertAfter(element.siblings('span.select2'))
          }
          else if (element.is(':radio') || element.is(':checkbox')) {
            label.insertAfter($('[data-name=\'' + element.attr('name') + '\']'))
          }
          else {
            label.insertAfter(element)
          }
    
          label.addClass('invalid-feedback')
        },
        rules: {
          title: {
            required: true,
          },
          key: {
            required: true,
          },
        },
        messages: {
          title: {
            required: 'Este campo es obligatorio.',
          },
          key: {
            required: 'Este campo es obligatorio.',
          },
        },
        submitHandler(form) {
          $('.btn-save, .btn-cancel').prop('disabled', true)
          $('.btn-save').find('.spinner-border').removeClass('d-none')
  
          form.submit()
        }
      })
    }
  }
</script>
